import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    // --------- Constructor ----------- //
    constructor(
    ) {}

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Clone the request object
        let newReq = req.clone();
        let currentUser;
        let token;
        if (localStorage.getItem('currentUser')) {
            currentUser = JSON.parse(localStorage.getItem('currentUser'));
            token = currentUser.token;
        }

        if (token) {
            let domainType = environment.domainType;
            if (domainType == 'com') {
                if (!req.url.includes('assets/') && !req.url.includes('oauth/gmail/imap')
                ) {
                    newReq = req.clone({
                        setHeaders: {
                            Authorization: `Bearer ${currentUser.token}`,
                            Accept: 'application/json',
                            'X-Member': `${currentUser.member_id}`,
                        },
                    });
                } else {
                    if (req.url.includes('assets/i18n/')) {
                        if (req.url.includes('undefined')) {
                            let abc = req.url;
                            abc = abc.replace('undefined', 'en');
                            localStorage.setItem('language', 'en');
                            newReq = req.clone({
                                url: abc,
                            });
                        }
                        if (req.url.includes('null')) {
                            let abc = req.url;
                            abc = abc.replace('null', 'en');
                            localStorage.setItem('language', 'en');
                            newReq = req.clone({
                                url: abc,
                            });
                        }
                    }
                }
            } else {
                if (!req.url.includes('assets/') && 
                    !req.url.includes('oauth/gmail/imap')
                ) {
                    newReq = req.clone({
                        setHeaders: {
                            Authorization: `Bearer ${currentUser.token}`,
                            Accept: 'application/json',
                            'X-Member': `${currentUser.member_id}`,
                        },
                    });
                } else {
                    if (req.url.includes('assets/i18n/')) {
                        if (req.url.includes('undefined')) {
                            let abc = req.url;
                            abc = abc.replace('undefined', 'en');
                            localStorage.setItem('language', 'en');
                            newReq = req.clone({
                                url: abc,
                            });
                        }
                    }
                }
            }
        }
        return next
            .handle(newReq)
            .pipe

            ();
    }
}
